(function () {
    'use strict';

    angular
        .module('app.addInfluencerToInfluencerGroup')
        .factory('addInfluencerToInfluencerGroupService', ['$q', '$http', '$rootScope',
            function ($q, $http, $rootScope)
            {
                var service = {};

                function handleRequest(url, method, params)
                {
                    var deferred = $q.defer();
                    var req = {
                        url: url,
                        method: method,
                        data: JSON.stringify(params)
                    }

                    $http(req).success(function (response) {
                        deferred.resolve(response);
                    })
                    .error(function () {
                        deferred.reject(null);
                    });

                    return deferred.promise;
                }

                function getInfluencerGroupNameForAddInfluencerError(influencer_group_id, company_id, influencer_id) {
                    var url_getInfluencerGroupNameForAddInfluencerError = $rootScope.apiUrl + 'influencerGroup/getInfluencerGroupNameForAddInfluencerError?influencer_group_id=' + influencer_group_id + '&company_id=' + company_id + '&influencer_id=' + influencer_id;
                    return handleRequest(url_getInfluencerGroupNameForAddInfluencerError, 'GET', null);
                }
                
                service.getInfluencerGroupNameForAddInfluencerError = getInfluencerGroupNameForAddInfluencerError;
                return service;
            }
        ])
})();
